import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Article from '../views/Article.vue'
import Author from '../views/Author.vue'
import Category from '../views/Category.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/article/:id',
    name: 'Article',
    component: Article
  },
  {
    path: '/author/:id',
    name: 'Author',
    component: Author
  },
  {
    path: '/category/:id/:currentId',
    name: 'Category',
    component: Category
  },
  {
    path: '/category/:id',
    name: 'Category',
    component: Category
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
